import React from "react";
import { Group, Badge, ActionIcon } from "@mantine/core";
import { IconX } from "@tabler/icons-react";
import { StackedQuery } from "../../models/QueryStack";
import { getGameString } from "../../utils/utils";

export interface QueryStackChipsProps {
  queries: StackedQuery[];
  editingQueryId?: string | null;
  onSelectQuery?: (query: StackedQuery) => void;
  onRemoveQuery?: (queryId: string) => void;
}

export const QueryStackChips: React.FC<QueryStackChipsProps> = ({
  queries,
  editingQueryId,
  onSelectQuery,
  onRemoveQuery,
}) => {
  if (queries.length === 0) return null;

  return (
    <Group gap={6} wrap="wrap" my={4}>
      {queries.map((q) => {
        const label =
          q.type === "player"
            ? `${q.player.fullName}${q.categories.length > 0 ? ` (${q.categories.join(", ")})` : ""}`
            : `${getGameString(q.game)}${q.categories.length > 0 ? ` (${q.categories.join(", ")})` : ""}`;
        const isSelected = editingQueryId === q.id;

        return (
          <Badge
            key={q.id}
            variant={isSelected ? "filled" : "light"}
            color="accent"
            radius="sm"
            size="sm"
            style={{ cursor: onSelectQuery ? "pointer" : "default" }}
            onClick={() => onSelectQuery?.(q)}
            rightSection={
              onRemoveQuery ? (
                <ActionIcon
                  size="xs"
                  color={isSelected ? "white" : "accent"}
                  radius="xl"
                  variant="transparent"
                  onClick={(e) => {
                    e.stopPropagation();
                    onRemoveQuery(q.id);
                  }}
                  aria-label={`Remove ${label}`}
                >
                  <IconX size={10} />
                </ActionIcon>
              ) : undefined
            }
          >
            {label}
          </Badge>
        );
      })}
    </Group>
  );
};

export default QueryStackChips;
